import * as actions from './actions'
import selectors from './selectors'
import { AppState, Dispatch } from '../../../types'
import { connect } from 'react-redux'
import { selectors as authSelectors } from '../../../lifecycle/auth';
import { Profile } from '../../../remote-api/CoreServicesRemoteApi'
import CustomMetrics, { EventProps, ValueProps } from './CustomMetrics'

const mapProps = (state: AppState, ownProps: ValueProps): ValueProps => ({
  ...ownProps,
  profile: authSelectors.getProfile(state).getOrUndefined() as Profile | undefined,
  metrics: selectors.metrics(state),
  selectedEnvironment: selectors.selectedEnvironment(state),
  isLoadingMetrics: selectors.isLoadingMetrics(state),
  customMetricsKey: selectors.customMetricsKey(state)
})

const mapDispatch = (dispatch: Dispatch, ownProps: ValueProps): EventProps => ({
  fetchCustomMetrics: () => dispatch(actions.fetchCustomMetrics(ownProps.orgId, ownProps.envId, ownProps.appId, ownProps.from, ownProps.to))
})

export default connect(mapProps, mapDispatch)(CustomMetrics)
